(function () {
  Drupal.behaviors.esearchHeaderPcV1 = {
    attach: function (context, settings) {
      var qs = generic.env.parsedQuery(),
        undef;

      if (qs.search != undef && qs.search.length > 0) {
        var $form = $('.site-content #perlgem-search-form'),
          $search = $('input[name="search"]', $form);

        // Replace the placeholder and value
        $search
          .attr('value', decodeURIComponent(qs.search));
      }

      // Populate and show the counter
      $(context).on('endeca.search.results.loaded', function (event, data) {
        var numResults = data.meta.totalAggrRecords;

        if ($search != undef) {
          var $count = $('.search-form__results-count', $form);

          $count
            .find('.number')
            .text(numResults)
            .end()
            .show();
        }
      });
    }
  };
})(jQuery);
